import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

export const MobileSearchV2Holder = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${spacing[12]};
  border-top: 1px solid var(--color-selectionGrey);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const MobileSearchV2IconHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;
